import { createSelector } from 'reselect';
import { flow, map, values, flatten, get } from 'lodash/fp';

function getMatchUpSelections(playersSubmitted, tiers) {
  const entrySelections = flow(
    values,
    flatten,
    map('id')
  )(playersSubmitted);
  return tiers.map(tier => {
    const a = tier.find(pId => entrySelections.includes(pId.toString()));
    if (!a) {
      console.error('problem finding matchups', playersSubmitted, tiers);
    }
    return a.toString();
  });
}

const matchUpSelectionsSelector = createSelector(
  get('entry.myEntry.playersSubmitted'),
  get('challenge.rapidfireTiers'),
  getMatchUpSelections
);

export default matchUpSelectionsSelector;
